var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRubyIcon2026(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Illustrations"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Container"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Wrapper"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Section"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Simple Illustration"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon=ruby"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip_ruby_icon_2026)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M37.616 36.2556C45.6002 27.8723 48.9269 17.9242 44.9348 14.1238C40.9428 10.3234 31.2952 14.0121 23.3111 22.3953C15.3269 30.7785 12.0002 40.7266 15.8814 44.527C19.7626 48.3274 29.6319 44.6388 37.616 36.2556Z",
    fill: "white",
    stroke: "#5B5BA8",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M67.113 19.9361C66.4476 16.8064 64.6733 14.5708 61.6793 13.4531C58.1308 12.1118 54.3605 12.6706 50.7011 12.7824C50.2575 12.7824 49.8139 13.006 49.5922 13.3413L49.7031 14.1237C49.7031 14.2355 49.7031 14.2355 49.7031 14.3473L50.812 20.7186L44.9347 35.0259L28.3011 49.3333L17.5446 50.3393L14.2179 46.0918C14.107 46.0918 13.9961 46.0918 13.7743 46.2036C12.9981 46.3154 12.9981 47.0978 12.8872 47.7685C12.7763 49.3333 12.6654 51.01 12.5545 52.5748C12.4436 53.8044 12.3328 55.0339 12.3328 56.2635C12.111 63.3054 16.103 67.6647 23.0892 67.6647C24.7526 67.6647 26.305 67.6647 27.9684 67.5529C34.6219 67.1058 41.2753 66.6587 47.9288 66.2116C52.808 65.8762 57.5763 65.5409 62.4555 65.2056C63.3427 65.0938 64.2298 65.0938 64.3407 63.7525C65.2278 51.01 66.3367 38.3792 67.2238 25.6367C67.5565 23.513 67.4456 21.7245 67.113 19.9361Z",
    fill: "white",
    stroke: "#5B5BA8",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M62.5665 45.533L61.2358 60.9581L48.0398 61.8523L62.5665 45.533Z",
    fill: "#7A2EFF",
    stroke: "#5B5BA8",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip_ruby_icon_2026"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRubyIcon2026);
export default __webpack_public_path__ + "static/media/ruby-icon-2026.91145642f60ca511bca903854b7afa61.svg";
export { ForwardRef as ReactComponent };